/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { JSONable } from '@irian-ro/abstract-resource';
import { HandoverContactDTO } from './handover-contact-dto.model';
import { DelAddressDtoModel } from '@well/address-management-shell-api';
import { TimeWindowDtoModel } from '@well/common-libs/time-management/domain-model';
import { NamedLocationPartnerContactVO, NamedLocationVo } from '@well/named-location-management/shell-api-domain';
import { Maybe } from '@irian-ro/util-functions';

export class HandoverDtoModel extends JSONable {
  uuid: string | null = null;
  owner: string | null = null;

  address: Maybe<DelAddressDtoModel> = null;

  namedLocationVO: Maybe<NamedLocationVo> = null;

  timeWindowDto: TimeWindowDtoModel | null = null;

  contact: HandoverContactDTO | null = new HandoverContactDTO();

  namedLocationPartnerContactVO: Maybe<NamedLocationPartnerContactVO> = null;

  companyName: string | null = null;

  loadingReference: string | null = null;

  deleted: boolean | null = null;
}
